// extracted by mini-css-extract-plugin
module.exports = {"wrapper__bundles":"Bundles_wrapper__bundles__oL0Lo"};